import { render, staticRenderFns } from "./authorization.vue?vue&type=template&id=a60bfd74&scoped=true"
import script from "./authorization.vue?vue&type=script&lang=js"
export * from "./authorization.vue?vue&type=script&lang=js"
import style0 from "./authorization.vue?vue&type=style&index=0&id=a60bfd74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60bfd74",
  null
  
)

export default component.exports